'use client';

import React from 'react';
import { useRouter } from 'next/navigation';
import Icon from '@/components/ui/AppIcon';
import AppImage from '@/components/ui/AppImage';

export default function NotFound() {
    const router = useRouter();

    const handleGoHome = () => {
        router.push('/');
    };

    const handleGoBack = () => {
        if (typeof window !== 'undefined') {
            window.history.back();
        }
    };

    return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-canopy p-4">
            <div className="text-center max-w-md">
                <div className="flex justify-center mb-6">
                    <div className="relative">
                        <h1 className="text-9xl font-bold text-chartreuse opacity-20">404</h1>
                    </div>
                </div>

                <h2 className="text-2xl font-medium text-text-primary mb-2">Halaman Tidak Ditemukan</h2>
                <p className="text-text-muted mb-8">
                    Halaman yang Anda cari tidak tersedia. Mari kembali ke beranda.
                </p>

                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                    <button
                        onClick={handleGoBack}
                        className="inline-flex items-center justify-center gap-2 bg-canopy border border-chartreuse/15 text-text-primary px-6 py-3 rounded-sm font-medium hover:bg-pond transition-colors duration-200"
                    >
                        <Icon name="ArrowLeftIcon" size={16} />
                        Kembali
                    </button>

                    <button
                        onClick={handleGoHome}
                        className="inline-flex items-center justify-center gap-2 btn-chartreuse px-6 py-3 rounded-sm font-medium transition-colors duration-200"
                    >
                        <Icon name="HomeIcon" size={16} />
                        Kembali ke Beranda
                    </button>
                </div>
            </div>
        </div>
    );
}
